import { createMiddleware } from "@tanstack/react-start"

import { getNightshiftRedirect } from "@/lib/terminal/nightshift-domain"

export const nightshiftRedirectMiddleware = createMiddleware().server(
  ({ request, next }) => {
    const location = getNightshiftRedirect(new URL(request.url))
    if (location === undefined) return next()
    return new Response(null, { status: 308, headers: { Location: location } })
  }
)
